import { Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LoginService } from '../services/login.service';
import { LoginRequest, MeResponse, TokenResponse } from '../models/auth.model';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  currentUser = signal<MeResponse | null>(null);

  constructor(private loginService: LoginService) { }

  login(payload: LoginRequest): Observable<TokenResponse> {
    return this.loginService.login(payload).pipe(
      tap((tokens) => this.storeTokens(tokens))
    );
  }

  refreshToken(): Observable<TokenResponse> {
    const refresh = this.getRefreshToken();
    return this.loginService.refreshToken({ refresh: refresh ?? '' }).pipe(
      tap((tokens) => this.storeTokens(tokens))
    );
  }

  fetchCurrentUser(): Observable<MeResponse> {
    return this.loginService.getMe().pipe(
      tap((user) => this.currentUser.set(user))
    );
  }

  logout(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    this.currentUser.set(null);
  }

  storeTokens(tokens: TokenResponse): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }
}
